import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TextField, Button, Typography, Grid, Avatar } from '@mui/material';
import FormContainer from 'containers/FormContainer';
import IntlMessages from 'lngProvider/IntlMessages';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { EmailValidation } from 'services/EnumConstants'
import { styled } from '@mui/material/styles';
import { colors, spacing } from 'styles/Common';

const StyledGrid = styled(Grid)((
    {
        theme
    }
    ) => {
        return {
            maxWidth: '300px',
            marginTop: spacing[9],
            '& .MuiInputBase-input': {
                height: 30
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                height: 48
            },
            '& .MuiButton-root': {
                borderRadius: '8px'
            },
            '& .MuiButton-contained.Mui-disabled': {
                backgroundColor: theme.palette.primary.light
            },
            '& .close-icon': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.primary.main,
                height: 40,
                width: 40,
                marginTop: spacing[4]
            },
            '& .title-text': {
                marginTop: spacing[9],
                fontWeight: 600
            },
            '& .subtitle-text': {
                marginTop: spacing[2],
                marginBottom: spacing[6]
            },
            '& .forgot-button': {
                color: colors.fillWhite,
                marginTop: spacing[2],
                marginBottom: spacing[7],
                height: 48,
                '& .MuiButton-contained.Mui-disabled': {
                    backgroundColor: theme.palette.primary.light
                }
            }
        };
    });

const ForgotPasswordMobile = (props) => {
    const emailRegex = EmailValidation.Production;

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .trim()
            .required(<IntlMessages id="forgotPassword.invalidEmail" />)
            .email(<IntlMessages id="forgotPassword.invalidEmail" />)
            .matches(emailRegex, true)
    });

    const location = useLocation();
    const { data, onSubmit, loginConfig, intl } = props;

    return (
        <FormContainer
            initialValues={data}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>

            {props => {
                const {
                    values,
                    errors,
                    touched,
                    isSubmitting,
                    handleChange
                } = props;

                return (
                    <StyledGrid>
                        <Link to={`/app/login${location.search}`}><Avatar className="close-icon"><CloseIcon /></Avatar></Link>
                        <Typography variant="h4" className="title-text"><IntlMessages id={loginConfig.forgotPasswordTitle} /></Typography>
                        {loginConfig && loginConfig.forgotPasswordSubTitle ?
                            <Typography variant="subtitle1" className="subtitle-text"><IntlMessages id={loginConfig.forgotPasswordSubTitle} /></Typography>
                        : ''}
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <TextField
                                    value={values.email}
                                    onChange={handleChange}
                                    error={errors.email && touched.email}
                                    helperText={((errors.email && touched.email) && errors.email)}
                                    name="email"
                                    placeholder={intl.formatMessage({ id: 'forgotPassword.email' })}
                                    inputProps={{ maxLength: 256 }}
                                    className="text-field"
                                    fullWidth />
                            </Grid>
                            <Grid item xs={12}>
                                <Button color="primary"
                                    type="submit"
                                    className="forgot-button"
                                    disabled={isSubmitting ||
                                        !!errors.password ||
                                        !values.email ||
                                        values.email === '' ||
                                        !!errors.email}
                                    fullWidth>
                                    <IntlMessages id={loginConfig.forgotPasswordButtonText} />
                                </Button>
                            </Grid>
                        </Grid>
                    </StyledGrid>
                );

            }}
        </FormContainer>
    );
}

export default ForgotPasswordMobile;

